webpackJsonp([0],{

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _httpErrorController = __webpack_require__(351);

var _httpErrorController2 = _interopRequireDefault(_httpErrorController);

var _httpError = __webpack_require__(352);

var _httpError2 = _interopRequireDefault(_httpError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var httpErrorModule = angular.module('http-error', []).directive('httpError', function () {
    'ngInject';

    return {
        retrict: 'EA',
        controller: _httpErrorController2.default,
        controllerAs: '$ctrl',
        bindToController: true,
        template: _httpError2.default
    };
}).name;

exports.default = httpErrorModule;

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(129);

__webpack_require__(326);

__webpack_require__(328);

__webpack_require__(329);

__webpack_require__(331);

/***/ }),

/***/ 329:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__(332);

__webpack_require__(333);

__webpack_require__(335);

var _index = __webpack_require__(336);

var _index2 = _interopRequireDefault(_index);

var _clpDashboardComponents = __webpack_require__(338);

var _clpDashboardComponents2 = _interopRequireDefault(_clpDashboardComponents);

var _conferencesComponents = __webpack_require__(357);

var _conferencesComponents2 = _interopRequireDefault(_conferencesComponents);

var _adminPortalComponents = __webpack_require__(360);

var _adminPortalComponents2 = _interopRequireDefault(_adminPortalComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// CLP Angular Module
angular.module('clpDashboard', ['slickCarousel', _index2.default, _clpDashboardComponents2.default]);

// Conferences Module
angular.module('conferenceDetails', [_conferencesComponents2.default]);

// Admin Modul
angular.module('adminPortal', ['720kb.datepicker', 'smart-table', _adminPortalComponents2.default]);

if ($('#clpDashboard').length > 0) {
    angular.bootstrap(document.getElementById('clpDashboard'), ['clpDashboard']);
}

if ($('#conferenceDetails').length > 0) {
    angular.bootstrap(document.getElementById('conferenceDetails'), ['conferenceDetails']);
}

if ($('#adminPortal').length > 0) {
    angular.bootstrap(document.getElementById('adminPortal'), ['adminPortal']);
}

__webpack_require__(365);
__webpack_require__(366);
__webpack_require__(367);
__webpack_require__(368);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(371);
__webpack_require__(372);
__webpack_require__(373);
__webpack_require__(374);
__webpack_require__(375);
__webpack_require__(376);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable */
/*!
 * angular-slick-carousel
 * DevMark <hc.devmark@gmail.com>
 * https://github.com/devmark/angular-slick-carousel
 * Version: 3.1.7 - 2016-08-04T06:43:29.508Z
 * License: MIT
 */



angular.module('slickCarousel', [])

//global config
.constant('slickCarouselConfig', {
  method: {},
  event: {}
}).directive('slick', ['$timeout', 'slickCarouselConfig', function ($timeout, slickCarouselConfig) {
  var slickMethodList, slickEventList;
  slickMethodList = ['slickGoTo', 'slickNext', 'slickPrev', 'slickPause', 'slickPlay', 'slickAdd', 'slickRemove', 'slickFilter', 'slickUnfilter', 'unslick'];
  slickEventList = ['afterChange', 'beforeChange', 'breakpoint', 'destroy', 'edge', 'init', 'reInit', 'setPosition', 'swipe', 'lazyLoaded', 'lazyLoadError'];

  return {
    scope: {
      settings: '=',
      enabled: '@',
      accessibility: '@',
      adaptiveHeight: '@',
      autoplay: '@',
      autoplaySpeed: '@',
      arrows: '@',
      asNavFor: '@',
      appendArrows: '@',
      prevArrow: '@',
      nextArrow: '@',
      centerMode: '@',
      centerPadding: '@',
      cssEase: '@',
      customPaging: '&',
      dots: '@',
      draggable: '@',
      fade: '@',
      focusOnSelect: '@',
      easing: '@',
      edgeFriction: '@',
      infinite: '@',
      initialSlide: '@',
      lazyLoad: '@',
      mobileFirst: '@',
      pauseOnHover: '@',
      pauseOnDotsHover: '@',
      respondTo: '@',
      responsive: '=?',
      rows: '@',
      slide: '@',
      slidesPerRow: '@',
      slidesToShow: '@',
      slidesToScroll: '@',
      speed: '@',
      swipe: '@',
      swipeToSlide: '@',
      touchMove: '@',
      touchThreshold: '@',
      useCSS: '@',
      variableWidth: '@',
      vertical: '@',
      verticalSwiping: '@',
      rtl: '@'
    },
    restrict: 'AE',
    link: function link(scope, element, attr) {
      //hide slider
      angular.element(element).css('display', 'none');

      var options, initOptions, destroy, init, destroyAndInit, currentIndex;

      initOptions = function initOptions() {
        options = angular.extend(angular.copy(slickCarouselConfig), {
          enabled: scope.enabled !== 'false',
          accessibility: scope.accessibility !== 'false',
          adaptiveHeight: scope.adaptiveHeight === 'true',
          autoplay: scope.autoplay === 'true',
          autoplaySpeed: scope.autoplaySpeed != null ? parseInt(scope.autoplaySpeed, 10) : 3000,
          arrows: scope.arrows !== 'false',
          asNavFor: scope.asNavFor ? scope.asNavFor : void 0,
          appendArrows: scope.appendArrows ? angular.element(scope.appendArrows) : angular.element(element),
          prevArrow: scope.prevArrow ? angular.element(scope.prevArrow) : void 0,
          nextArrow: scope.nextArrow ? angular.element(scope.nextArrow) : void 0,
          centerMode: scope.centerMode === 'true',
          centerPadding: scope.centerPadding || '50px',
          cssEase: scope.cssEase || 'ease',
          customPaging: attr.customPaging ? function (slick, index) {
            return scope.customPaging({ slick: slick, index: index });
          } : void 0,
          dots: scope.dots === 'true',
          draggable: scope.draggable !== 'false',
          fade: scope.fade === 'true',
          focusOnSelect: scope.focusOnSelect === 'true',
          easing: scope.easing || 'linear',
          edgeFriction: scope.edgeFriction || 0.15,
          infinite: scope.infinite !== 'false',
          initialSlide: parseInt(scope.initialSlide) || 0,
          lazyLoad: scope.lazyLoad || 'ondemand',
          mobileFirst: scope.mobileFirst === 'true',
          pauseOnHover: scope.pauseOnHover !== 'false',
          pauseOnDotsHover: scope.pauseOnDotsHover === "true",
          respondTo: scope.respondTo != null ? scope.respondTo : 'window',
          responsive: scope.responsive || void 0,
          rows: scope.rows != null ? parseInt(scope.rows, 10) : 1,
          slide: scope.slide || '',
          slidesPerRow: scope.slidesPerRow != null ? parseInt(scope.slidesPerRow, 10) : 1,
          slidesToShow: scope.slidesToShow != null ? parseInt(scope.slidesToShow, 10) : 1,
          slidesToScroll: scope.slidesToScroll != null ? parseInt(scope.slidesToScroll, 10) : 1,
          speed: scope.speed != null ? parseInt(scope.speed, 10) : 300,
          swipe: scope.swipe !== 'false',
          swipeToSlide: scope.swipeToSlide === 'true',
          touchMove: scope.touchMove !== 'false',
          touchThreshold: scope.touchThreshold ? parseInt(scope.touchThreshold, 10) : 5,
          useCSS: scope.useCSS !== 'false',
          variableWidth: scope.variableWidth === 'true',
          vertical: scope.vertical === 'true',
          verticalSwiping: scope.verticalSwiping === 'true',
          rtl: scope.rtl === 'true'
        }, scope.settings);
      };

      destroy = function destroy() {
        var slickness = $(element);
        if (slickness.hasClass('slick-initialized')) {
          slickness.remove('slick-list');
          slickness.slick('unslick');
        }

        return slickness;
      };

      init = function init() {
        initOptions();

        var slickness = $(element);

        if (angular.element(element).hasClass('slick-initialized')) {
          if (options.enabled) {
            return slickness.slick('getSlick');
          } else {
            destroy();
          }
        } else {
          if (!options.enabled) {
            return;
          }
          // Event
          slickness.on('init', function (event, slick) {
            if (typeof options.event.init !== 'undefined') {
              options.event.init(event, slick);
            }
            if (typeof currentIndex !== 'undefined') {
              return slick.slideHandler(currentIndex);
            }
          });

          $timeout(function () {
            angular.element(element).css('display', 'block');
            slickness.not('.slick-initialized').slick(options);
          });
        }

        scope.internalControl = options.method || {};

        // Method
        slickMethodList.forEach(function (value) {
          scope.internalControl[value] = function () {
            var args;
            args = Array.prototype.slice.call(arguments);
            args.unshift(value);
            slickness.slick.apply(element, args);
          };
        });

        // Event
        slickness.on('afterChange', function (event, slick, currentSlide) {
          currentIndex = currentSlide;
          if (typeof options.event.afterChange !== 'undefined') {
            $timeout(function () {
              scope.$apply(function () {
                options.event.afterChange(event, slick, currentSlide);
              });
            });
          }
        });

        slickness.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          if (typeof options.event.beforeChange !== 'undefined') {
            $timeout(function () {
              $timeout(function () {
                scope.$apply(function () {
                  options.event.beforeChange(event, slick, currentSlide, nextSlide);
                });
              });
            });
          }
        });

        slickness.on('reInit', function (event, slick) {
          if (typeof options.event.reInit !== 'undefined') {
            $timeout(function () {
              scope.$apply(function () {
                options.event.reInit(event, slick);
              });
            });
          }
        });

        if (typeof options.event.breakpoint !== 'undefined') {
          slickness.on('breakpoint', function (event, slick, breakpoint) {
            $timeout(function () {
              scope.$apply(function () {
                options.event.breakpoint(event, slick, breakpoint);
              });
            });
          });
        }
        if (typeof options.event.destroy !== 'undefined') {
          slickness.on('destroy', function (event, slick) {
            $timeout(function () {
              scope.$apply(function () {
                options.event.destroy(event, slick);
              });
            });
          });
        }
        if (typeof options.event.edge !== 'undefined') {
          slickness.on('edge', function (event, slick, direction) {
            $timeout(function () {
              scope.$apply(function () {
                options.event.edge(event, slick, direction);
              });
            });
          });
        }

        if (typeof options.event.setPosition !== 'undefined') {
          slickness.on('setPosition', function (event, slick) {
            $timeout(function () {
              scope.$apply(function () {
                options.event.setPosition(event, slick);
              });
            });
          });
        }
        if (typeof options.event.swipe !== 'undefined') {
          slickness.on('swipe', function (event, slick, direction) {
            $timeout(function () {
              scope.$apply(function () {
                options.event.swipe(event, slick, direction);
              });
            });
          });
        }
        if (typeof options.event.lazyLoaded !== 'undefined') {
          slickness.on('lazyLoaded', function (event, slick, image, imageSource) {
            $timeout(function () {
              scope.$apply(function () {
                options.event.lazyLoaded(event, slick, image, imageSource);
              });
            });
          });
        }
        if (typeof options.event.lazyLoadError !== 'undefined') {
          slickness.on('lazyLoadError', function (event, slick, image, imageSource) {
            $timeout(function () {
              scope.$apply(function () {
                options.event.lazyLoadError(event, slick, image, imageSource);
              });
            });
          });
        }
      };

      destroyAndInit = function destroyAndInit() {
        destroy();
        init();
      };

      element.one('$destroy', function () {
        destroy();
      });

      return scope.$watch('settings', function (newVal, oldVal) {
        if (newVal !== null) {
          return destroyAndInit();
        }
      }, true);
    }
  };
}]);
/* eslint-enable */
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _chapterDuesProfile = __webpack_require__(339);

var _chapterDuesProfile2 = _interopRequireDefault(_chapterDuesProfile);

var _memberBreakdown = __webpack_require__(341);

var _memberBreakdown2 = _interopRequireDefault(_memberBreakdown);

var _memberRenewal = __webpack_require__(343);

var _memberRenewal2 = _interopRequireDefault(_memberRenewal);

var _rebatesReimbursements = __webpack_require__(345);

var _rebatesReimbursements2 = _interopRequireDefault(_rebatesReimbursements);

var _leaderList = __webpack_require__(347);

var _leaderList2 = _interopRequireDefault(_leaderList);

var _loadingSpinner = __webpack_require__(91);

var _loadingSpinner2 = _interopRequireDefault(_loadingSpinner);

var _httpError = __webpack_require__(127);

var _httpError2 = _interopRequireDefault(_httpError);

var _renewalMessage = __webpack_require__(353);

var _renewalMessage2 = _interopRequireDefault(_renewalMessage);

var _uploadCpe = __webpack_require__(355);

var _uploadCpe2 = _interopRequireDefault(_uploadCpe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComponentsModule = angular.module('clp-components', [_chapterDuesProfile2.default, _memberBreakdown2.default, _memberRenewal2.default, _rebatesReimbursements2.default, _leaderList2.default, _loadingSpinner2.default, _httpError2.default, _renewalMessage2.default, _uploadCpe2.default]).name;

exports.default = ComponentsModule;

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _chapterDuesProfileController = __webpack_require__(340);

var _chapterDuesProfileController2 = _interopRequireDefault(_chapterDuesProfileController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var chapterDuesProfileModule = angular.module('chapter-dues-profile', []).directive('chapterDuesProfile', function () {
    'ngInject';

    return {
        retrict: 'EA',
        controller: _chapterDuesProfileController2.default,
        controllerAs: '$ctrl',
        scope: {},
        bindToController: true,
        transclude: true,
        link: function link(scope, element, attrs, ctrlr, transclude) {
            transclude(scope, function (clone, scope) {
                element.append(clone);
            });
        }
    };
}).name;

exports.default = chapterDuesProfileModule;

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChapterDuesProfileController = function () {
    ChapterDuesProfileController.$inject = ["$http", "$window", "$timeout"];
    function ChapterDuesProfileController($http, $window, $timeout) {
        'ngInject';

        _classCallCheck(this, ChapterDuesProfileController);

        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;

        this.data = [];
        this.spinner = true;

        this.httpError = false;
    }

    _createClass(ChapterDuesProfileController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$timeout(function () {
                _this.$http({
                    url: '/api/chapterleader/getchapterdues',
                    method: 'GET'
                }).then(function (response) {
                    _this.data = response.data;
                    _this.spinner = false;
                }, function (response) {
                    _this.spinner = false;
                    _this.httpError = true;
                });
            }, 1000);
        }
    }]);

    return ChapterDuesProfileController;
}();

exports.default = ChapterDuesProfileController;

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _memberBreakdownController = __webpack_require__(342);

var _memberBreakdownController2 = _interopRequireDefault(_memberBreakdownController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var memberBreakdownModule = angular.module('member-breakdown', []).directive('memberBreakdown', function () {
    'ngInject';

    return {
        retrict: 'EA',
        controller: _memberBreakdownController2.default,
        controllerAs: '$ctrl',
        scope: {},
        bindToController: true,
        transclude: true,
        link: function link(scope, element, attrs, ctrlr, transclude) {
            transclude(scope, function (clone, scope) {
                element.append(clone);
            });
        }
    };
}).name;

exports.default = memberBreakdownModule;

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MemberBreakdownController = function () {
    MemberBreakdownController.$inject = ["$http", "$window", "$timeout"];
    function MemberBreakdownController($http, $window, $timeout) {
        'ngInject';

        _classCallCheck(this, MemberBreakdownController);

        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;

        this.data = [];
        this.spinner = true;

        this.httpError = false;
    }

    _createClass(MemberBreakdownController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$timeout(function () {
                _this.$http({
                    url: '/api/chapterleader/getchaptersummary',
                    method: 'GET'
                }).then(function (response) {
                    _this.data = response.data;
                    _this.spinner = false;
                }, function (response) {
                    _this.spinner = false;
                    _this.httpError = true;
                });
            }, 1000);
        }
    }]);

    return MemberBreakdownController;
}();

exports.default = MemberBreakdownController;

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _memberRenewalController = __webpack_require__(344);

var _memberRenewalController2 = _interopRequireDefault(_memberRenewalController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var memberRenewalModule = angular.module('member-renewal', []).directive('memberRenewal', function () {
    'ngInject';

    return {
        retrict: 'EA',
        controller: _memberRenewalController2.default,
        controllerAs: '$ctrl',
        scope: {},
        bindToController: true,
        transclude: true,
        link: function link(scope, element, attrs, ctrlr, transclude) {
            transclude(scope, function (clone, scope) {
                element.append(clone);
            });
        }
    };
}).name;

exports.default = memberRenewalModule;

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MemberRenewalController = function () {
    MemberRenewalController.$inject = ["$http", "$window", "$timeout"];
    function MemberRenewalController($http, $window, $timeout) {
        'ngInject';

        _classCallCheck(this, MemberRenewalController);

        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;

        this.data = [];
        this.currentYear = new Date().getFullYear();
        this.context = 0;
        this.contextLastYear = 0;
        this.context2YrsAgo = 0;

        this.spinner = true;
        this.httpError = false;

        this.slickConfig = {
            enabled: true,
            dots: true,
            draggable: false,
            cssEase: 'linear',
            method: {}
        };
    }

    _createClass(MemberRenewalController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$timeout(function () {
                _this.$http({
                    url: '/api/chapterleader/getchaptersummary',
                    method: 'GET'
                }).then(function (response) {
                    _this.data = response.data;

                    _this.context = _this.data.MemberRenewalPercent.replace(/[^0-9.]/g, '') / 100 * 180;
                    _this.contextLastYear = _this.data.MemberRenewalPercentLastYear.replace(/[^0-9.]/g, '') / 100 * 180;
                    _this.context2YrsAgo = _this.data.MemberRenewalPercent2YrsAgo.replace(/[^0-9.]/g, '') / 100 * 180;

                    _this.spinner = false;
                }, function (response) {
                    _this.spinner = false;
                    _this.httpError = true;
                });
            }, 1000);
        }
    }]);

    return MemberRenewalController;
}();

exports.default = MemberRenewalController;

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rebatesReimbursementsController = __webpack_require__(346);

var _rebatesReimbursementsController2 = _interopRequireDefault(_rebatesReimbursementsController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rebatesReimbursementsModule = angular.module('rebates-reimbursements', []).directive('rebatesReimbursements', function () {
    'ngInject';

    return {
        retrict: 'EA',
        controller: _rebatesReimbursementsController2.default,
        controllerAs: '$ctrl',
        scope: {},
        bindToController: true,
        transclude: true,
        link: function link(scope, element, attrs, ctrlr, transclude) {
            transclude(scope, function (clone, scope) {
                element.append(clone);
            });
        }
    };
}).name;

exports.default = rebatesReimbursementsModule;

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RebatesReimbursementsController = function () {
    RebatesReimbursementsController.$inject = ["$scope", "$http", "$window", "$timeout"];
    function RebatesReimbursementsController($scope, $http, $window, $timeout) {
        'ngInject';

        _classCallCheck(this, RebatesReimbursementsController);

        this.$scope = $scope;
        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;

        this.data = {};

        this.spinner = false;
        this.httpError = false;
    }

    _createClass(RebatesReimbursementsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.spinner = true;
            this.$timeout(function () {
                _this.$http({
                    url: '/api/chapterleader/getchapterrebates',
                    method: 'GET'
                }).then(function (response) {
                    _this.spinner = false;
                    _this.data = response.data;
                    console.log(_this.data);
                }, function (response) {
                    _this.spinner = false;
                    _this.httpError = true;
                });
            }, 1000);
        }
    }]);

    return RebatesReimbursementsController;
}();

exports.default = RebatesReimbursementsController;

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _leaderListController = __webpack_require__(348);

var _leaderListController2 = _interopRequireDefault(_leaderListController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var memberRenewalModule = angular.module('leader-list', []).directive('leaderList', function () {
    'ngInject';

    return {
        retrict: 'EA',
        controller: _leaderListController2.default,
        controllerAs: '$ctrl',
        scope: {},
        bindToController: true,
        transclude: true,
        link: function link(scope, element, attrs, ctrlr, transclude) {
            transclude(scope, function (clone, scope) {
                element.append(clone);
            });
        }
    };
}).name;

exports.default = memberRenewalModule;

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LeaderListController = function () {
    LeaderListController.$inject = ["$http", "$window", "$element", "$timeout"];
    function LeaderListController($http, $window, $element, $timeout) {
        'ngInject';

        _classCallCheck(this, LeaderListController);

        this.$http = $http;
        this.$window = $window;
        this.$element = $element;
        this.$timeout = $timeout;

        this.data = [];
        this.dataOverflow = [];
        this.isOverflow = false;

        this.collapsed = true;
        this.collapsing = false;

        this.spinner = true;

        this.httpError = false;
    }

    _createClass(LeaderListController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$timeout(function () {
                _this.$http({
                    url: '/api/chapterleader/getchapterleaders',
                    method: 'GET'
                }).then(function (response) {
                    if (response.data.length > 8) {
                        _this.data = response.data.splice(0, 8);
                        _this.dataOverflow = response.data;
                        _this.isOverflow = true;
                    } else {
                        _this.data = response.data;
                    }
                    _this.spinner = false;
                }, function (response) {
                    _this.spinner = false;
                    _this.httpError = true;
                });
            }, 1000);
        }
    }, {
        key: 'toggleOverflow',
        value: function toggleOverflow() {
            var _this2 = this;

            if (this.collapsed) {
                this.collapsing = true;
                this.$timeout(function () {
                    _this2.collapsing = !_this2.collapsing;
                    _this2.collapsed = !_this2.collapsed;
                });
                $('.c-leader-list .js-focus').focus();
            } else {
                this.collapsed = !this.collapsed;
            }
        }
    }, {
        key: 'focusTrap',
        value: function focusTrap() {
            if (!this.collapsed) {
                $('.js-focus').focus();
            }
        }
    }]);

    return LeaderListController;
}();

exports.default = LeaderListController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoadingSpinnerController = function () {
    LoadingSpinnerController.$inject = ["$window"];
    function LoadingSpinnerController($window) {
        'ngInject';

        _classCallCheck(this, LoadingSpinnerController);

        this.$window = $window;

        this.outerSize = 40;
        this.midSize = 0;
        this.innerSize = 0;
        this.outerStyle = {};
        this.midStyle = {};
        this.innerStyle = {};
    }

    _createClass(LoadingSpinnerController, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.size) {
                this.outerSize = this.size;
            }
            this.midSize = this.outerSize - 8;
            this.innerSize = this.outerSize - 16;

            this.outerStyle = { 'height': this.outerSize + 'px', 'width': this.outerSize + 'px' };
            this.midStyle = { 'height': this.midSize + 'px', 'width': this.midSize + 'px' };
            this.innerStyle = { 'height': this.innerSize + 'px', 'width': this.innerSize + 'px' };
        }
    }]);

    return LoadingSpinnerController;
}();

exports.default = LoadingSpinnerController;

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

module.exports = "<div class=\"c-spinner\" ng-style=\"$ctrl.outerStyle\">\r\n    <div class=\"c-spinner__item\">\r\n        <div class=\"c-spinner__outer\" ng-style=\"$ctrl.outerStyle\">\r\n            <div class=\"c-spinner__outer-item\" ng-style=\"$ctrl.outerStyle\"></div>\r\n            <div class=\"c-spinner__outer-item\" ng-style=\"$ctrl.outerStyle\"></div>\r\n            <div class=\"c-spinner__outer-item\" ng-style=\"$ctrl.outerStyle\"></div>\r\n            <div class=\"c-spinner__outer-item\" ng-style=\"$ctrl.outerStyle\"></div>\r\n        </div>\r\n    </div>\r\n    <div class=\"c-spinner__item\">\r\n        <div class=\"c-spinner__mid\" ng-style=\"$ctrl.midStyle\">\r\n            <div class=\"c-spinner__mid-item\" ng-style=\"$ctrl.midStyle\"></div>\r\n            <div class=\"c-spinner__mid-item\" ng-style=\"$ctrl.midStyle\"></div>\r\n            <div class=\"c-spinner__mid-item\" ng-style=\"$ctrl.midStyle\"></div>\r\n            <div class=\"c-spinner__mid-item\" ng-style=\"$ctrl.midStyle\"></div>\r\n        </div>\r\n    </div>\r\n    <div class=\"c-spinner__item\">\r\n        <div class=\"c-spinner__inner\" ng-style=\"$ctrl.innerStyle\">\r\n            <div class=\"c-spinner__inner-item\" ng-style=\"$ctrl.innerStyle\"></div>\r\n            <div class=\"c-spinner__inner-item\" ng-style=\"$ctrl.innerStyle\"></div>\r\n            <div class=\"c-spinner__inner-item\" ng-style=\"$ctrl.innerStyle\"></div>\r\n            <div class=\"c-spinner__inner-item\" ng-style=\"$ctrl.innerStyle\"></div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var httpErrorController = function httpErrorController($window) {
    'ngInject';

    _classCallCheck(this, httpErrorController);

    this.$window = $window;
};
httpErrorController.$inject = ["$window"];

exports.default = httpErrorController;

/***/ }),

/***/ 352:
/***/ (function(module, exports) {

module.exports = "<p class=\"h-http-error\">\r\n    <span class=\"h-http-error__accent\">Uh oh, there was a problem loading your data.</span class=\"h-http-error__accent\"><br />\r\n    If the problem persists, please contact us to resolve the error.\r\n</p>"

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _renewalMessageController = __webpack_require__(354);

var _renewalMessageController2 = _interopRequireDefault(_renewalMessageController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renewalMessageModule = angular.module('renewal-message', []).directive('renewalMessage', function () {
    'ngInject';

    return {
        retrict: 'EA',
        controller: _renewalMessageController2.default,
        controllerAs: '$ctrl',
        scope: {
            chapterId: '@'
        },
        bindToController: true,
        transclude: true,
        link: function link(scope, element, attrs, ctrlr, transclude) {
            transclude(scope, function (clone, scope) {
                element.append(clone);
            });
        }
    };
}).name;

exports.default = renewalMessageModule;

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RenewalMessageController = function () {
    RenewalMessageController.$inject = ["$scope", "$http", "$window", "$timeout"];
    function RenewalMessageController($scope, $http, $window, $timeout) {
        'ngInject';

        _classCallCheck(this, RenewalMessageController);

        this.$scope = $scope;
        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;

        this.spinner = false;
        this.httpError = false;

        // Final Upload Statuses
        this.success = false;
        this.error = false;

        // Identifiers
        this.texareaID = '#renewalMessage';

        // Default Values
        this.errorMsg = '';
    }

    _createClass(RenewalMessageController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.spinner = true;
            this.$timeout(function () {
                _this.$http({
                    url: '/api/chapterleader/GetCLPRenewalMessage',
                    method: 'POST',
                    data: { chapterId: _this.chapterId }
                }).then(function (response) {
                    _this.spinner = false;
                    $(_this.texareaID).val(response.data.RenewalMessage);
                }, function (response) {
                    _this.spinner = false;
                    _this.error = true;
                    _this.errorMsg = response;
                });
            }, 1000);
        }
    }, {
        key: 'updateMessage',
        value: function updateMessage() {
            var _this2 = this;

            this.spinner = true;
            this.success = false;
            this.error = false;
            var messageTxt = $(this.texareaID).val();
            this.$timeout(function () {
                _this2.$http({
                    url: '/api/chapterleader/UploadCLPRenewalMessage',
                    method: 'POST',
                    data: {
                        chapterId: _this2.chapterId,
                        message: messageTxt
                    }
                }).then(function (response) {
                    if (response.data.SuccessStatus) {
                        _this2.spinner = false;
                        _this2.success = true;
                    } else {
                        _this2.spinner = false;
                        _this2.error = true;
                        _this2.errorMsg = response.data.ErrorStatus;
                    }
                }, function (response) {
                    _this2.spinner = false;
                    _this2.error = true;
                    _this2.errorMsg = response;
                });
            }, 1000);
        }
    }]);

    return RenewalMessageController;
}();

exports.default = RenewalMessageController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _uploadCpeController = __webpack_require__(356);

var _uploadCpeController2 = _interopRequireDefault(_uploadCpeController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uploadCPEModule = angular.module('upload-cpe', []).directive('uploadCpe', function () {
    'ngInject';

    return {
        retrict: 'EA',
        controller: _uploadCpeController2.default,
        controllerAs: '$ctrl',
        scope: {
            validColumns: '@',
            rowThreshold: '@',
            dateFormat: '@',
            eventStartDateRange: '@',
            qualifyingActivity: '@',
            methodofDelivery: '@',
            isacaMemberNumberDigits: '@',
            cpeHours: '@'
        },
        bindToController: true,
        transclude: true,
        link: function link(scope, element, attrs, ctrlr, transclude) {
            transclude(scope, function (clone, scope) {
                element.append(clone);
            });
        }
    };
}).name;

exports.default = uploadCPEModule;

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UploadCPEController = function () {
    UploadCPEController.$inject = ["$scope", "$http", "$window", "$timeout"];
    function UploadCPEController($scope, $http, $window, $timeout) {
        'ngInject';

        _classCallCheck(this, UploadCPEController);

        this.$scope = $scope;
        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;

        this.spinner = true;
        this.httpError = false;

        this.fileUploaded = false;

        // Final Upload Statuses
        this.success = false;
        this.error = false;
        this.modalSuccess = false;
        this.modalError = false;

        // Selectors
        this.overlayID = '#loadingOverlay';
        this.fileUploadFormID = '#uploadForm';
        this.fileUploadInputID = '#fileUploadInput';

        // Default Values
        this.errorMsg = '';
        this.fileName = '[File Name].XLSX';
    }

    _createClass(UploadCPEController, [{
        key: 'triggerClientUpload',
        value: function triggerClientUpload() {
            this.success = false;
            this.error = false;
            this.modalSuccess = false;
            this.modalError = false;
            $(this.fileUploadInputID).trigger('click');
        }
    }, {
        key: 'displayFileName',
        value: function displayFileName() {
            this.fileName = $(this.fileUploadInputID).get(0).files[0].name;
            this.fileUploaded = true;
            this.$scope.$apply();
        }
    }, {
        key: 'uploadFile',
        value: function uploadFile() {
            var _this = this;

            if (window.FormData !== undefined) {
                // Initialization
                this.spinner = true;
                this.success = false;
                this.error = false;
                this.modalSuccess = false;
                this.modalError = false;
                $(this.overlayID).overlay();

                // Fetch uploaded file
                var file = $(this.fileUploadInputID).get(0).files[0];

                /* eslint-disable */
                var fileData = new FormData();
                /* eslint-enable */
                fileData.append(file.name, file);
                fileData.append('validColumns', this.validColumns);
                fileData.append('rowThreshold', this.rowThreshold);
                fileData.append('dateFormat', this.dateFormat);
                fileData.append('eventStartDateRange', this.eventStartDateRange);
                fileData.append('qualifyingActivity', this.qualifyingActivity);
                fileData.append('methodofDelivery', this.methodofDelivery);
                fileData.append('iSACAMemberNumberDigits', this.isacaMemberNumberDigits);
                fileData.append('cpeHours', this.cpeHours);
                this.$timeout(function () {
                    _this.$http({
                        url: '/api/chapterleader/UploadCPEFile',
                        method: 'POST',
                        transformRequest: angular.identity,
                        headers: {
                            'Content-Type': undefined
                        },
                        data: fileData
                    }).then(function (response) {
                        if (!response.data.ErrorStatus) {
                            _this.spinner = false;
                            _this.success = true;
                            _this.modalSuccess = true;
                        } else {
                            if (response.data.ErrorStatus && !response.data.SuccessStatus) {
                                _this.errorMsg = response.data.ErrorStatus;
                                _this.spinner = false;
                                _this.error = true;
                                _this.modalError = true;
                            } else {
                                if (response.data.ErrorStatus && response.data.SuccessStatus) {
                                    _this.errorMsg = response.data.ErrorStatus;
                                    _this.spinner = false;
                                    _this.success = true;
                                    _this.error = true;
                                    _this.modalSuccess = true;
                                }
                            }
                        }
                    }, function (response) {
                        _this.errorMsg = response;
                        _this.spinner = false;
                        _this.error = true;
                        _this.modalError = true;
                    });
                }, 750);
            } else {
                this.errorMsg = 'Uh oh! It looks like there was an issue with selecting your file. Try selecting your file again.';
                this.error = true;
                this.modalError = true;
                this.fileUploaded = false;
            }
        }
    }, {
        key: 'toggleOverlay',
        value: function toggleOverlay() {
            if (this.success || this.error) {
                $(this.overlayID).overlay();
            }
        }
    }]);

    return UploadCPEController;
}();

exports.default = UploadCPEController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _conferenceDetails = __webpack_require__(358);

var _conferenceDetails2 = _interopRequireDefault(_conferenceDetails);

var _httpError = __webpack_require__(127);

var _httpError2 = _interopRequireDefault(_httpError);

var _loadingSpinner = __webpack_require__(91);

var _loadingSpinner2 = _interopRequireDefault(_loadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComponentsModule = angular.module('conferences-components', [_conferenceDetails2.default, _httpError2.default, _loadingSpinner2.default]).filter('trim', function () {
    return function (value) {
        if (!angular.isString(value)) {
            return value;
        }
        return value.trim();
    };
}).name;

exports.default = ComponentsModule;

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _conferenceDetailsController = __webpack_require__(359);

var _conferenceDetailsController2 = _interopRequireDefault(_conferenceDetailsController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var conferenceDetailsModule = angular.module('conference-details', []).directive('conferenceDetails', function () {
    'ngInject';

    return {
        retrict: 'EA',
        controller: _conferenceDetailsController2.default,
        controllerAs: '$ctrl',
        scope: {
            conferenceId: '@',
            conferencePackageId: '@',
            userStatus: '@',
            charLimit: '@',
            mode: '@',
            isRegistered: '=',
            onLoad: '@',
            review: '@',
            workshopOnly: '@',
            allowChanges: '='
        },
        bindToController: true,
        transclude: true,
        link: function link(scope, element, attrs, ctrlr, transclude) {
            transclude(scope, function (clone, scope) {
                element.append(clone);
            });
        }
    };
}).name;

exports.default = conferenceDetailsModule;

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ConferenceDetailsController = function () {
    ConferenceDetailsController.$inject = ["$http", "$window", "$timeout"];
    function ConferenceDetailsController($http, $window, $timeout) {
        'ngInject';

        _classCallCheck(this, ConferenceDetailsController);

        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;

        // Initialize ajax/api controls
        this.data = {};
        this.spinner = true;
        this.httpError = false;

        // Initialize models for filter and radio button controls
        this.radioModel = {};
        this.filterModel = {};
        this.dayTime = {};

        // Initialize arrays to manage valid sessions
        this.validSessions = [];
        this.validSessionsPerCat = [];

        // Initialize no results toggle
        this.noResults = false;

        // Initialize edit message toggle
        this.msgToggle = false;

        // Intialize pagination per day functionality
        this.selected = 0;

        // Initialize character limit bool
        this.charLimit = true;
    }

    _createClass(ConferenceDetailsController, [{
        key: '$onInit',
        value: function $onInit() {
            if (typeof this.onLoad !== 'undefined' && this.onLoad !== null) {
                if (this.onLoad === 'true') {
                    this.loadSchedule();
                }
            }
        }
    }, {
        key: 'loadSchedule',
        value: function loadSchedule() {
            var _this = this;

            this.spinner = true;
            this.$timeout(function () {
                _this.$http({
                    url: '/api/conference/conferencesessions?id=' + _this.conferenceId + '&cpid=' + _this.conferencePackageId,
                    method: 'GET'
                }).then(function (response) {
                    _this.data = response.data;
                    // Initialize model to manage radio button binding and session highlighting
                    _this.setRadioBindings();
                    // Initialize model that defines the filters and filter categories returned from the API
                    for (var filter in _this.data.ConferenceTagGroups) {
                        _this.filterModel[filter] = {};
                        _this.filterModel[filter].active = false;
                        _this.filterModel[filter].name = _this.data.ConferenceTagGroups[filter].GroupName;
                        _this.filterModel[filter].items = {};
                        for (var filterItem in _this.data.ConferenceTagGroups[filter].Tags) {
                            _this.filterModel[filter].items[filterItem] = {};
                            _this.filterModel[filter].items[filterItem].value = false;
                            _this.filterModel[filter].items[filterItem].valueString = _this.data.ConferenceTagGroups[filter].Tags[filterItem];
                        }
                    }
                    _this.spinner = false;
                    // Initialize filters to display items on page load
                    _this.setFilters();
                    if (typeof _this.$window.isacaDp.feature.conferenceTabs !== 'undefined') {
                        _this.$window.isacaDp.feature.conferenceTabs.loadSessionsCallback();
                    }
                }, function (response) {
                    _this.spinner = false;
                    _this.httpError = true;
                });
            }, 1000);
        }
    }, {
        key: 'setFilters',
        value: function setFilters() {
            this.noResults = true;
            // Clear all existing filters and/or valid sessions to get ready for filter handling
            this.clearCategories();
            this.validSessionsPerCat = [];
            // Loop through filter categores
            for (var category in this.filterModel) {
                // Then loop through individual filters in that category
                for (var item in this.filterModel[category].items) {
                    // If any filter in that category is active...
                    if (this.filterModel[category].items[item].value) {
                        if (!this.filterModel[category].active) {
                            // Then set it's filter category to active
                            this.filterModel[category].active = true;
                        }
                    }
                }
            }
            // Ooohwee, here we go...
            // Loop through the days of each conference
            for (var day in this.data.ConferenceDays) {
                // Then loop through the timeslots of each day
                for (var timeslot in this.data.ConferenceDays[day].ConfTimeSlots) {
                    // Then loop through each session of each day
                    for (var session in this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions) {
                        //  Then loop through each filter category
                        for (var filterCat in this.filterModel) {
                            // If that filter category is set to active
                            if (this.filterModel[filterCat].active) {
                                // Then we filter through each filter of that category
                                for (var filterItem in this.filterModel[filterCat].items) {
                                    // If that filter is set to active
                                    if (this.filterModel[filterCat].items[filterItem].value) {
                                        // Loop through each filter tag in this session
                                        for (var tag in this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].ConfTags) {
                                            // If the filter tag name in this session matches the active filter category
                                            if (this.filterModel[filterCat].name === this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].ConfTags[tag].TagName) {
                                                // And if the filter tag value matches this session's filter tag value
                                                if (this.filterModel[filterCat].items[filterItem].valueString === this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].ConfTags[tag].TagValue) {
                                                    // Then we add an array to our valid sessions array and add the value to our new array
                                                    if (typeof this.validSessionsPerCat[filterCat] === 'undefined') {
                                                        this.validSessionsPerCat[filterCat] = [];
                                                    }
                                                    this.validSessionsPerCat[filterCat].push(this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].ProductId);
                                                } else {
                                                    // Otherwise we create the array anyway in the case no values match
                                                    if (typeof this.validSessionsPerCat[filterCat] === 'undefined') {
                                                        this.validSessionsPerCat[filterCat] = [];
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            } else {
                                // If the filter isn't set to active, we add all sessions to this category's array because they are all valid
                                if (typeof this.validSessionsPerCat[filterCat] === 'undefined') {
                                    this.validSessionsPerCat[filterCat] = [];
                                }
                                this.validSessionsPerCat[filterCat].push(this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].ProductId);
                            }
                        }
                    }
                }
            }
            // This is magically crossreferencing our array of arrays (all valid sessions in each filter category)
            // This will return one array of each session that appears in each filter category array
            var arrays = this.validSessionsPerCat;
            this.validSessions = arrays.shift().reduce(function (res, v) {
                if (res.indexOf(v) === -1 && arrays.every(function (a) {
                    return a.indexOf(v) !== -1;
                })) res.push(v);
                return res;
            }, []);
            // Initialize model that keeps track of valid timeslot and days while filtering
            this.setDayTimeBindings();
        }
    }, {
        key: 'filter',
        value: function filter() {
            var _this2 = this;

            return function (item) {
                // Use default Angular filtering to loop each valid session in our array of valid sessions, then return only items that match a ProductId with that array
                for (var id in _this2.validSessions) {
                    if (_this2.validSessions[id] === item.ProductId) {
                        return item;
                    }
                }
            };
        }
    }, {
        key: 'toggleSpinnerOverlay',
        value: function toggleSpinnerOverlay(id) {
            $(id).overlay();
        }
    }, {
        key: 'cancelUpdate',
        value: function cancelUpdate() {
            this.msgToggle = false;
            // Reset all values in the binded radio button model
            // This will reset all radio buttons and session highlighting
            this.setRadioBindings();
        }
    }, {
        key: 'toggleDay',
        value: function toggleDay(key) {
            // Toggle day pagination when user clicks on day they wish to view.
            // Mobile has an entirely different view which this condition controls
            if (this.$window.innerWidth < 1024 || this.$window.innerHeight < 700) {
                if (this.selected !== key) {
                    this.selected = key;
                } else {
                    this.selected = '';
                }
            } else {
                this.selected = key;
            }
        }
    }, {
        key: 'toggleRadio',
        value: function toggleRadio($event, page, timeslot, id) {
            $event.preventDefault();
            $event.stopPropagation();
            this.msgToggle = true;
            if (this.radioModel[page][timeslot].value === id) {
                this.radioModel[page][timeslot].value = '';
            } else {
                this.radioModel[page][timeslot].value = id;
            }
        }
    }, {
        key: 'toggleCharLimit',
        value: function toggleCharLimit(session) {
            // Simply toggling to show the full description in corresponding session
            session.toggle = !session.toggle;
        }
    }, {
        key: 'clearAll',
        value: function clearAll() {
            // We're clearing filters so we might as well deactivate the filter categories also
            this.clearCategories();
            // Loop through each category filter
            for (var category in this.filterModel) {
                // Then loop through individual filter of each category
                for (var filter in this.filterModel[category].items) {
                    // Then deactive that filter
                    this.filterModel[category].items[filter].value = false;
                }
            }
            // Reset filters so that users don't have to hit the Apply button
            this.setFilters();
        }
    }, {
        key: 'clearCategories',
        value: function clearCategories() {
            // Deactivating each filter category
            for (var category in this.filterModel) {
                this.filterModel[category].active = false;
            }
        }
    }, {
        key: 'setRadioBindings',
        value: function setRadioBindings() {
            // Build model to manage radio button binding and session highlighting
            for (var day in this.data.ConferenceDays) {
                this.radioModel[day] = {};
                for (var timeslot in this.data.ConferenceDays[day].ConfTimeSlots) {
                    this.radioModel[day][timeslot] = {};
                    this.radioModel[day][timeslot].value = '';
                    for (var session in this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions) {
                        if (this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].IsRegistered) {
                            this.radioModel[day][timeslot].value = this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].ProductId;
                        }
                    }
                }
            }
        }
    }, {
        key: 'setDayTimeBindings',
        value: function setDayTimeBindings() {
            // Check if this is View Itinerary
            if (this.userStatus !== 'anonymous' && this.isRegistered && this.mode !== 'edit') {
                // If it is, valid day/time bindings based off of each session's IsRegistered Field
                for (var day in this.data.ConferenceDays) {
                    this.dayTime[day] = {};
                    this.dayTime[day].valid = false;
                    this.dayTime[day].items = {};
                    for (var timeslot in this.data.ConferenceDays[day].ConfTimeSlots) {
                        this.dayTime[day].items[timeslot] = {};
                        this.dayTime[day].items[timeslot].valid = false;
                        this.dayTime[day].items[timeslot].hidden = true;
                        for (var session in this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions) {
                            if (this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].IsRegistered || this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].ProductId === '') {
                                // Then this day becomes valid
                                if (!this.dayTime[day].valid) {
                                    this.dayTime[day].valid = true;
                                }
                                // and this timeslot becomes valid
                                if (!this.dayTime[day].items[timeslot].valid) {
                                    if (this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].FunctionType !== 'Registration') {
                                        this.dayTime[day].items[timeslot].hidden = false;
                                    }
                                    this.dayTime[day].items[timeslot].valid = true;
                                }
                            }
                        }
                    }
                }
            } else if (this.review) {
                for (day in this.data.ConferenceDays) {
                    this.dayTime[day] = {};
                    this.dayTime[day].valid = false;
                    this.dayTime[day].items = {};
                    for (timeslot in this.data.ConferenceDays[day].ConfTimeSlots) {
                        this.dayTime[day].items[timeslot] = {};
                        this.dayTime[day].items[timeslot].valid = false;
                        this.dayTime[day].items[timeslot].hidden = true;
                        for (session in this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions) {
                            if (this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].IsSelected || this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].FunctionType === 'Registration' || this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].FunctionType === 'Break') {
                                // Then this day becomes valid
                                if (!this.dayTime[day].valid) {
                                    this.dayTime[day].valid = true;
                                }
                                // and this timeslot becomes valid
                                if (!this.dayTime[day].items[timeslot].valid) {
                                    this.dayTime[day].items[timeslot].valid = true;
                                }
                            }
                        }
                    }
                }
            } else {
                for (day in this.data.ConferenceDays) {
                    this.dayTime[day] = {};
                    this.dayTime[day].valid = false;
                    this.dayTime[day].items = {};
                    for (timeslot in this.data.ConferenceDays[day].ConfTimeSlots) {
                        this.dayTime[day].items[timeslot] = {};
                        this.dayTime[day].items[timeslot].valid = false;
                        this.dayTime[day].items[timeslot].hidden = true;
                    }
                }
                // Loop through each day
                for (day in this.data.ConferenceDays) {
                    // Then loop through each timeslot
                    for (timeslot in this.data.ConferenceDays[day].ConfTimeSlots) {
                        // The loop through each sessions
                        for (session in this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions) {
                            // In each session loop through each valid session
                            for (var validSession in this.validSessions) {
                                // If the one of the valid sessions in this day.timeslot is valid
                                if (this.validSessions[validSession] === this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].ProductId) {
                                    // Then this day becomes valid
                                    if (!this.dayTime[day].valid) {
                                        this.dayTime[day].valid = true;
                                    }
                                    // and this timeslot becomes valid
                                    if (!this.dayTime[day].items[timeslot].valid) {
                                        if (this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].FunctionType !== 'Registration' && this.data.ConferenceDays[day].ConfTimeSlots[timeslot].ConfSessions[session].FunctionType !== 'Break') {
                                            this.dayTime[day].items[timeslot].hidden = false;
                                        }
                                        this.dayTime[day].items[timeslot].valid = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Check if there are any results
            for (day in this.dayTime) {
                if (this.dayTime[day].valid) {
                    this.selected = parseInt(day);
                    this.noResults = false;
                    break;
                }
            }
        }
    }]);

    return ConferenceDetailsController;
}();

exports.default = ConferenceDetailsController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _adminDatagrid = __webpack_require__(361);

var _adminDatagrid2 = _interopRequireDefault(_adminDatagrid);

var _eventFunction = __webpack_require__(363);

var _eventFunction2 = _interopRequireDefault(_eventFunction);

var _loadingSpinner = __webpack_require__(91);

var _loadingSpinner2 = _interopRequireDefault(_loadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComponentsModule = angular.module('admin-components', [_adminDatagrid2.default, _eventFunction2.default, _loadingSpinner2.default]).name;

exports.default = ComponentsModule;

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _adminDatagridController = __webpack_require__(362);

var _adminDatagridController2 = _interopRequireDefault(_adminDatagridController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adminDatagridModule = angular.module('admin-datagrid', []).directive('adminDatagrid', function () {
    'ngInject';

    return {
        retrict: 'EA',
        controller: _adminDatagridController2.default,
        controllerAs: '$ctrl',
        scope: {
            srcData: '@',
            itemsPerPage: '@',
            filterSelectProperty: '@'
        },
        bindToController: true,
        transclude: true,
        link: function link(scope, element, attrs, ctrlr, transclude) {
            transclude(scope, function (clone, scope) {
                element.append(clone);
            });
        }
    };
}).name;

exports.default = adminDatagridModule;

/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdminDatagridController = function () {
    AdminDatagridController.$inject = ["$http", "$window", "$timeout"];
    function AdminDatagridController($http, $window, $timeout) {
        'ngInject';

        _classCallCheck(this, AdminDatagridController);

        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;

        this.data = [];
        this.filterCategory = [];

        this.startDate = '';
        this.endDate = '';
    }

    _createClass(AdminDatagridController, [{
        key: '$onInit',
        value: function $onInit() {
            this.data = JSON.parse(this.srcData.replace(/'/g, '"'));
            var inArray = false;
            for (var index in this.data) {
                if (this.filterCategory.length > 0) {
                    inArray = false;
                    for (var i = 0; i < this.filterCategory.length; i++) {
                        if (this.data[index][this.filterSelectProperty] === this.filterCategory[i]) {
                            inArray = true;
                        }
                    }
                    if (!inArray) {
                        this.filterCategory.push(this.data[index][this.filterSelectProperty]);
                    }
                } else {
                    this.filterCategory.push(this.data[index][this.filterSelectProperty]);
                }
            }
        }
    }, {
        key: 'dateFilter',
        value: function dateFilter(startDate, endDate, startOnFilter, endOnFilter) {
            return function (item) {
                var isStart = false;
                var isEnd = false;
                var isBoth = false;
                if (startDate !== '') {
                    isStart = true;
                }
                if (endDate !== '') {
                    isEnd = true;
                }
                if (isStart && isEnd) {
                    isBoth = true;
                }
                if (isBoth) {
                    if (new Date(startDate) < new Date(item[startOnFilter]) && new Date(endDate) > new Date(item[endOnFilter])) {
                        return item;
                    }
                } else if (isStart) {
                    if (new Date(startDate) < new Date(item[startOnFilter])) {
                        return item;
                    }
                } else if (isEnd) {
                    if (new Date(endDate) > new Date(item[endOnFilter])) {
                        return item;
                    }
                } else {
                    return item;
                }
            };
        }
    }]);

    return AdminDatagridController;
}();

exports.default = AdminDatagridController;

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _eventFunctionController = __webpack_require__(364);

var _eventFunctionController2 = _interopRequireDefault(_eventFunctionController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eventFunctionModule = angular.module('event-function', []).directive('eventFunction', function () {
    'ngInject';

    return {
        retrict: 'EA',
        controller: _eventFunctionController2.default,
        controllerAs: '$ctrl',
        bindToController: true,
        transclude: true,
        link: function link(scope, element, attrs, ctrlr, transclude) {
            transclude(scope, function (clone, scope) {
                element.append(clone);
            });
        }
    };
}).name;

exports.default = eventFunctionModule;

/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventFunctionController = function () {
    EventFunctionController.$inject = ["$http", "$window", "$timeout"];
    function EventFunctionController($http, $window, $timeout) {
        'ngInject';

        _classCallCheck(this, EventFunctionController);

        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;

        this.data = [];
        this.errorMessage = '';

        this.spinner = true;
        this.error = false;
    }

    _createClass(EventFunctionController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$timeout(function () {
                _this.$http({
                    url: '/api/sitecore/IsacaCatalog/GetAccountCodes',
                    method: 'GET'
                }).then(function (response) {
                    _this.data = response.data;
                    // if(response.data.Success === 'true' || response.data.Success === 'True') {
                    //     this.data = response.data.Data;
                    // } else {
                    //     this.errorMessage = response.data.Message;
                    //     this.error = true;
                    // }
                    _this.spinner = false;
                }, function (response) {
                    _this.errorMessage = 'There was a error with fetching your data.';
                    _this.spinner = false;
                    _this.error = true;
                    console.log(response);
                });
            }, 1000);
        }
    }]);

    return EventFunctionController;
}();

exports.default = EventFunctionController;

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery, $) {

(function ($) {
    var $el = $('[data-collapse-toggle]');
    $el.on('click', function () {
        btnTrigger($(this));
        $($(this).data('target')).collapseToggle();
    });
    $.fn.collapseToggle = function () {
        this.slideToggle('fast');
        this.focus();
    };
})(jQuery);

function btnTrigger($el) {
    $el.attr('aria-expanded', function (i, attr) {
        return attr === 'true' ? 'false' : 'true';
    });
    $($el.data('target')).attr('aria-hidden', function (i, attr) {
        return attr === 'true' ? 'false' : 'true';
    });
    if ($el.attr('aria-expanded') === 'true') {
        $el.addClass('expanded');
    } else {
        $el.removeClass('expanded');
    }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(5)))

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

(function ($) {
    var toggleSelector = '-visible';
    if ($('.h-overlay.-visible').length > 0) {
        $('body').addClass('h-overlay__open');
    }
    $.fn.overlay = function ($el) {
        $(this).toggleClass(toggleSelector);
        $(this).attr('aria-hidden', function (i, attr) {
            return attr === 'true' ? 'false' : 'true';
        });
        if ($($($el).data('target')).attr('aria-hidden') === 'false') {
            $('body').addClass('h-overlay__open');
        } else {
            $('body').removeClass('h-overlay__open');
        }
    };
})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

(function ($) {
    var $el = $('[data-modal]');
    if ($el.length > 0) {
        $el.on('click', function () {
            $($(this).data('target')).overlay($(this));
        });
    }
})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

(function ($) {
    if ($('.js-slick-grid')) {
        $('.js-slick-grid').each(function () {
            var instance = $(this);
            instance.slick({
                dots: true,
                prevArrow: instance.closest('.c-grid-gallery').find('.c-pagination__btn--prev'),
                nextArrow: instance.closest('.c-grid-gallery').find('.c-pagination__btn--next'),
                appendDots: instance.closest('.c-grid-gallery').find('.c-pagination__numeration'),
                customPaging: function customPaging(slider, pageIndex) {
                    return '<button class="c-pagination__btn c-pagination__btn--pagination">' + (pageIndex + 1) + '</button>';
                }
            });
        });
    }
})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

$('.clp-resources-hero').slick({
    dots: true
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery, $) {

(function ($) {
    var $el = $('[data-terms]');
    var $toggle = $('[data-terms="toggle"]');
    if ($el.length > 0) {
        $el.on('click', function () {
            btnTrigger($(this), $toggle);
        });
    }
})(jQuery);

function btnTrigger($el, $toggle) {
    if ($el.attr('data-target') && $el.data('target') !== '') {
        $($el.data('target')).overlay();
    }
    if ($el.data('terms') === 'agree') {
        $toggle.toggleClass('-no-access');
    }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(5)))

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery, $) {

(function ($) {
    var $el = $('[data-download]');
    if ($el.length > 0) {
        $el.on('click', function (e) {
            e.preventDefault();
            var id = $(this).data('download');
            btnTrigger(id);
        });
    }
})(jQuery);

function btnTrigger(id) {
    $.ajax({
        url: '/api/chapterleader/downloadredirect?id=' + id,
        type: 'GET',
        success: function success(data) {
            window.open(data, '_self');
        },
        error: function error() {
            window.alert('File Download Failed');
        }
    });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(5)))

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

(function ($) {
    var mobileClass = 'mobile-toggle';
    var $elDisplay = $('[data-privacy-display]');
    if ($elDisplay.length > 0) {
        var $elAccept = $('[data-privacy-accept]');
        var $elDelete = $('[data-privacy-delete]');
        if ($elAccept.length > 0) {
            var cookies = [];
            var allAgreed = true;
            for (var i = 0; i < $elAccept.length; i++) {
                cookies[$($elAccept[i]).data('id')] = readCookie($($elAccept[i]).data('id'));
            }
            for (var name in cookies) {
                if (cookies[name] === 'true') {
                    toggleVisibility($('[data-privacy-display="' + name + '"]'));
                } else {
                    allAgreed = false;
                }
            }
            if (allAgreed) {
                toggleVisibility($elDisplay);
            }
            $elAccept.on('click', function () {
                closeMobile($(this).closest('.isaca-consent-privacy'), mobileClass);
                createCookie($(this).data('id'), 'true', $(this).data('cookie-policy-expiration'));
                toggleVisibility($('[data-privacy-display="' + $(this).data('id') + '"]'));
            });
        } else {
            toggleVisibility($elDisplay);
        }

        // For Testing
        if ($elDelete.length > 0) {
            $elDelete.on('click', function () {
                eraseCookie($(this).data('id'));
            });
        }

        var $elToggleMobile = $('[data-privacy-details]');
        $elToggleMobile.on('click', function () {
            if (!$(this).closest('.isaca-consent-privacy').hasClass(mobileClass)) {
                $(this).addClass(mobileClass);
                $(this).closest('.isaca-consent-privacy').addClass(mobileClass);
                $($(this).data('parent')).addClass(mobileClass);
                $($(this).data('target')).addClass(mobileClass);
            } else {
                if ($(this).hasClass(mobileClass)) {
                    $(this).removeClass(mobileClass);
                    $(this).closest('.isaca-consent-privacy').removeClass(mobileClass);
                    $($(this).data('parent')).removeClass(mobileClass);
                    $($(this).data('target')).removeClass(mobileClass);
                } else {
                    $(this).closest('.isaca-consent-privacy').find('.privacy-col').removeClass(mobileClass);
                    $(this).closest('.isaca-consent-privacy').find('.isaca-consent-text-toggle').removeClass(mobileClass);
                    $(this).closest('.isaca-consent-privacy').find('.isaca-consent-text').removeClass(mobileClass);
                    $(this).addClass(mobileClass);
                    $(this).closest('.isaca-consent-privacy').addClass(mobileClass);
                    $($(this).data('parent')).addClass(mobileClass);
                    $($(this).data('target')).addClass(mobileClass);
                }
            }
        });
        var $elToggleMobileClose = $('[data-privacy-details-close]');
        $elToggleMobileClose.on('click', function () {
            closeMobile($(this).closest('.isaca-consent-privacy'), mobileClass);
        });
    }
})(jQuery);

function toggleVisibility($el) {
    $el.remove();
}

function createCookie(name, value, days) {
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toGMTString();
    }
    document.cookie = name + '=' + value + expires + ';secure';
}

function readCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, '', -1);
}

function closeMobile($container, mobileClass) {
    $container.removeClass(mobileClass);
    $container.find('.privacy-col').removeClass(mobileClass);
    $container.find('.isaca-consent-text-toggle').removeClass(mobileClass);
    $container.find('.isaca-consent-text').removeClass(mobileClass);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery, $) {

(function ($) {
    var $toggleNewAddress = $('[data-radio-toggle]');
    var $paymentTabs = $('[data-payment-tab]');
    var $payLater = $('[data-pay-later]');
    var $noPaymentRequired = $('[data-no-payment-required]');
    var $countrySelect = $('[data-country-select]');
    var $newAddressForm = $('[data-new-address-form]');

    if ($toggleNewAddress.length > 0) {
        for (var i = 0; i < $toggleNewAddress.length; i++) {
            if ($($($toggleNewAddress[i]).find('input'))[0].checked) {
                setHiddenFields($($toggleNewAddress[i]));
            }
        }
        var toggleClass = 'new-billing-form--active';
        $toggleNewAddress.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if ($(this).attr('data-target')) {
                $(this).attr('aria-expanded', 'true');
                $($(this).data('target')).attr('aria-hidden', 'false');
                $($(this).data('target')).show('fast');
                $($(this).data('target')).addClass(toggleClass);
            } else {
                for (i = 0; i < $toggleNewAddress.length; i++) {
                    if (typeof $($toggleNewAddress[i]).attr('aria-expanded') !== 'undefined') {
                        $($toggleNewAddress[i]).attr('aria-expanded', 'false');
                    }
                }
                $('.' + toggleClass).attr('aria-hidden', 'true');
                $('.' + toggleClass).hide('fast');
            }
            $(this).find('input').prop('checked', true);
            setHiddenFields($(this));
        });
    }
    if ($paymentTabs.length > 0) {
        var $paymentPages = $('[data-payment-page]');
        $paymentTabs.on('click', function () {
            $paymentTabs.removeClass('selected');
            $paymentTabs.attr('aria-expanded', 'false');
            $(this).addClass('selected');
            $(this).attr('aria-expanded', 'true');
            if ($paymentPages.length > 0) {
                $paymentPages.attr('aria-hidden', 'true');
                $paymentPages.removeClass('selected');
                $($(this).data('target')).addClass('selected');
                $($(this).data('target')).attr('aria-hidden', 'false');
            }
        });
    }
    $payLater.on('click', function () {
        var payLaterModel = {};
        payLaterModel[$('#thankyouPageUrl').attr('name')] = $('#thankyouPageUrl').val();
        payLaterModel['PayLater'] = true;
        loadPayLaterAPI(payLaterModel);
    });
    $noPaymentRequired.on('click', function () {
        var payLaterModel = {};
        payLaterModel['PayLater'] = false;
        loadNoPaymentRequiredAPI(payLaterModel);
    });
    var countryModel = {};
    if (!($countrySelect.val() === '')) {
        countryModel['CountryCode'] = $countrySelect.val();
        loadStates(countryModel);
    }
    $countrySelect.change(function () {
        countryModel['CountryCode'] = $(this).val();
        loadStates(countryModel);
    });
    $newAddressForm.on('submit', function () {
        // remove disable on state field if needed to add to post back
        $('#states').prop('disabled', false);
    });
})(jQuery);

function setHiddenFields($el) {
    var $fields = $el.find('[data-property]');
    var existingAddressModel = {};
    for (var i = 0; i < $fields.length; i++) {
        existingAddressModel[$($fields[i]).data('property')] = $($fields[i]).text();
    }
    var $hiddenFields = $('[data-property-input]');
    if ($hiddenFields.length > 0) {
        if ($el.find('input').val() === 'ExistingAddress') {
            for (i = 0; i < $hiddenFields.length; i++) {
                $($hiddenFields[i]).attr('value', existingAddressModel[$($hiddenFields[i]).attr('name')]);
            }
        } else {
            for (i = 0; i < $hiddenFields.length; i++) {
                if ($($hiddenFields[i]).attr('name') === 'IsExisting') {
                    $($hiddenFields[i]).val('false');
                }
            }
        }
    }
}

function loadPayLaterAPI(data) {
    var $error = $('[data-paylater-error]');
    $error.hide();
    $error.empty();
    var url = 'api/checkout/PayLaterAndSubmitOrder';
    $('[data-checkout-loading]').overlay();
    setTimeout(function () {
        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            success: function success(response) {
                /* eslint-disable */
                if (response.Success || response.Success === 'true') {
                    window.open(response.ReturnUrl, '_self');
                    $('[data-checkout-loading]').overlay();
                } else {
                    window.open(response.ReturnUrl, '_self');
                    $('[data-checkout-loading]').overlay();
                }
                /* eslint-enable */
            },
            error: function error(xhr, status, _error) {
                $('[data-checkout-loading]').overlay();
                if ($error.length > 0) {
                    $error.show();
                    $error.append('<p><span class="h-http-error__accent">Uh oh, there was a problem loading your data.</span><br>If the problem persists, please contact us to resolve the error.</p>');
                    console.log(xhr.status);
                }
            }
        });
    }, 1000);
}

function loadNoPaymentRequiredAPI(data) {
    var $error = $('[data-paylater-error]');
    $error.hide();
    $error.empty();
    var url = 'api/checkout/ApplyZeroPaymentAndSubmitOrder';
    $('[data-checkout-loading]').overlay();
    setTimeout(function () {
        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            success: function success(response) {
                /* eslint-disable */
                if (response.Success || response.Success === 'true') {
                    window.open(response.ReturnUrl, '_self');
                    $('[data-checkout-loading]').overlay();
                } else {
                    window.open(response.ReturnUrl, '_self');
                    $('[data-checkout-loading]').overlay();
                }
                /* eslint-enable */
            },
            error: function error(xhr, status, _error2) {
                $('[data-checkout-loading]').overlay();
                if ($error.length > 0) {
                    $error.show();
                    $error.append('<p><span class="h-http-error__accent">Uh oh, there was a problem loading your data.</span><br>If the problem persists, please contact us to resolve the error.</p>');
                    console.log(xhr.status);
                }
            }
        });
    }, 1000);
}

function loadStates(data) {
    var $stateSelect = $('[data-state-select]');
    $stateSelect.empty();
    /* eslint-disable */
    ConferenceRegistrationProfile.checkStateValidation($stateSelect, data.CountryCode, false);
    /* eslint-enable */
    $stateSelect.parent().find('.c-spinner').show();
    $stateSelect.parent().find('.label-text').hide();
    if ($stateSelect.length > 0) {
        var url = '/api/checkout/GetSubdivisions';
        setTimeout(function () {
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                success: function success(response) {
                    var selected = '';
                    if (Object.keys(response.States).length === 1) {
                        selected = 'selected';
                    } else {
                        $stateSelect.append('<option selected></option>');
                    }

                    for (var state in response.States) {
                        $stateSelect.append('<option ' + selected + ' value="' + state + '">' + response.States[state] + '</option>');
                    }
                    $stateSelect.parent().find('.c-spinner').hide();
                    $stateSelect.parent().find('.label-text').show();
                },
                error: function error(xhr, status, _error3) {
                    console.log(xhr.status);
                    $stateSelect.parent().find('.c-spinner').hide();
                    $stateSelect.parent().find('.label-text').show();
                }
            });
        }, 250);
    }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(5)))

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery, $) {

(function ($) {
    var $el = $('[data-char-limit]');
    for (var i = 0; i < $el.length; i++) {
        // Check if each applicable div has a character count higher than its defined character limit
        if ($($el[i]).text().length > $($el[i]).data('char-limit')) {
            // If it is, clip the text and append a 'Show more' button to the end of it
            clipText($($el[i]), $($el[i]).data('char-limit'));
            // Add a cick event handle to toggle hidden content
            $($el[i]).find('.c-char-limit--btn').on('click', function () {
                $(this).parents('[data-char-limit]').find('.c-char-limit').toggleClass('-visible');
            });
        }
    }
})(jQuery);

function clipText($el, charLimit) {
    var hidden = $($el).text().substring(charLimit);
    // Build markup for hidden items and toggle button. Hidden items shown by toggling -visible class
    $($el).html($($el).text().substring(0, charLimit) + '<span class="c-char-limit -visible">...</span>\n    <span class="c-char-limit">' + hidden + '</span>\n    <button type="button" class="c-btn c-btn--link c-char-limit--btn">\n        Show \n        <span class="c-char-limit -visible">more</span>\n        <span class="c-char-limit">less</span>\n    </button>');
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(5)))

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery, $) {

(function ($) {
    var $el = $('[data-admin-email]');
    for (var i = 0; i < $el.length; i++) {
        $($el[i]).on('click', function () {
            $($(this).data('target')).overlay();
            loadAPI($(this).data('order-id'), $(this).data('user-id'), $(this).data('target'), $(this));
        });
    }
})(jQuery);

function loadAPI(orderId, customerId, overlayId, $triggerEl) {
    var url = '/api/commerceadminorder/sendorderemail';
    var data = {
        'OrderId': orderId,
        'CustomerId': customerId
    };
    $(overlayId).find('.c-spinner').show();
    $(overlayId).find('.h-response-message--success').hide();
    $(overlayId).find('.h-response-message--error').hide().find('p').remove();
    $(overlayId).find('.c-overlay__close').hide();
    setTimeout(function () {
        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            success: function success(response) {
                $(overlayId).find('.c-spinner').hide();
                $(overlayId).find('.c-overlay__close').show();
                if (response.Success) {
                    $(overlayId).find('.h-response-message--success').show();
                    $triggerEl.css({ 'opacity': '0.6', 'cursor': 'not-allowed' }).attr('disabled', 'disabled');
                } else {
                    $(overlayId).find('.h-response-message--error').show().append('<p>' + response.Message + '</p>');
                }
            },
            error: function error(xhr, status, _error) {
                $(overlayId).find('.c-overlay__close').show();
                $(overlayId).find('.c-spinner').hide();
                $(overlayId).find('.h-response-message--error').show().append('<p>' + _error + '</p>');
                console.log(_error);
            }
        });
    }, 750);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(5)))

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery, $) {

(function ($) {
    var activeTab = splitUrlQuery(window.location.search);
    if (typeof activeTab !== 'undefined') {
        redirect(activeTab);
    }
    var $btn = $('[data-redirect]');
    $btn.on('click', function () {
        redirect($(this).data('redirect').toString());
        $('html, body').animate({
            scrollTop: $($(this).data('target')).offset().top
        }, 500);
    });
})(jQuery);

function redirect(page) {
    var $navTabs = $('.nav-tab__link--conference');
    var $navTabsMobile = $('.nav-tab__link--conference-mobile');
    $navTabs.removeClass('nav-tab__link--active');
    $navTabsMobile.removeClass('nav-tab__link--active');
    for (var i = 0; i < $navTabs.length; i++) {
        if ($($navTabs[i]).data('nav-tab').toString() === page) {
            $($navTabs[i]).addClass('nav-tab__link--active');
            angular.element('.nav-tab__link--mobile[data-nav-tab="' + page + '"]').trigger('click');
        }
        if ($($navTabsMobile[i]).data('nav-tab').toString() === page) {
            $($navTabsMobile[i]).addClass('nav-tab__link--active');
        }
    }
}

function splitUrlQuery(url) {
    var urlVariables = url.substring(1).split('&');
    for (var i = 0; i < urlVariables.length; i++) {
        var param = urlVariables[i].split('=');
        if (param[0] === 'tab') {
            return param[1];
        }
    }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(5)))

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _loadingSpinnerController = __webpack_require__(349);

var _loadingSpinnerController2 = _interopRequireDefault(_loadingSpinnerController);

var _loadingSpinner = __webpack_require__(350);

var _loadingSpinner2 = _interopRequireDefault(_loadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadingSpinnerModule = angular.module('loading-spinner', []).directive('loadingSpinner', function () {
    'ngInject';

    return {
        retrict: 'EA',
        controller: _loadingSpinnerController2.default,
        controllerAs: '$ctrl',
        scope: { size: '@' },
        bindToController: true,
        template: _loadingSpinner2.default
    };
}).name;

exports.default = loadingSpinnerModule;

/***/ })

},[128]);


// WEBPACK FOOTER //
// scripts/js/app.bundle.js